import { defineComponent, onMounted } from 'vue';
import LoadForCampaignCreationCode from '@/presentation/pages/load-for-campaign-creation/load-for-campaign-creation.code';

export default defineComponent({
	setup: () => {
		const code = new LoadForCampaignCreationCode();

		onMounted(code.mounted.bind(code));

		return {};
	}
});
